import { Component, OnInit } from '@angular/core';

@Component({ templateUrl: './stream-keyword-guide.component.html' })
export class StreamKeywordGuideComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
